module.exports = __webpack_public_path__ + "media/styles/images/png/inline-arrow-up-teal-155e10644263df94d49afab1393e3acc.png";